import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast as toastify } from "react-toastify";

export const Toast = () => (
  <ToastContainer
    position="bottom-left"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop
    closeOnClick={false}
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
);

const TOAST_TYPES = [undefined, "info", "success", "warning", "error", "dark"];

export const toast = (type, content) => {
  if (!TOAST_TYPES.includes(type)) {
    console.warn("'" + type + "' is not an expected type value for toast");
    type = undefined;
  }
  toastify(<ToastContent content={content} />, {
    type,
    autoClose: type === "error" || type === "warning" ? false : undefined,
  });
};

const ToastContent = (props) => {
  const { content } = props;
  const [hide, setHide] = useState(typeof content === "string" && content.length > 200);
  const { t } = useTranslation("common");

  if (typeof content !== "string") {
    return content;
  }

  if (hide) {
    return (
      <div>
        {(content.slice(0, 200) + "...").split("\n").map((s, i) => (
          <p key={i}>{s}</p>
        ))}
        <button onClick={() => setHide(false)}>{t("show_all")}</button>
      </div>
    );
  }

  return content.split("\n").map((s, i) => <p key={i}>{s}</p>);
};
